import { Statistic, Table } from 'antd';
import React, { useRef, useState } from 'react';
import {SearchColumn} from '../../Components/TableSettings/TableSettings';
import {UnorderedListOutlined} from "@ant-design/icons";
import DataTable from '../../Components/DataTable/DataTable';
import { PageHeader } from '@ant-design/pro-components';
const data = [
  {
    key: '1',
    name: 'John Brown',
    age: 32,
    address: 'New York No. 1 Lake Park',
  },
  {
    key: '2',
    name: 'Joe Black',
    age: 42,
    address: 'London No. 1 Lake Park',
  },
  {
    key: '3',
    name: 'Jim Green',
    age: 32,
    address: 'Sidney No. 1 Lake Park',
  },
  {
    key: '4',
    name: 'Jim Red',
    age: 32,
    address: 'London No. 2 Lake Park',
  },
];

const ReservedList = () => {
    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);
    const Search = new SearchColumn(searchText ,setSearchText ,searchedColumn , setSearchedColumn , searchInput);
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      width: '30%',
      ...Search.getColumnSearchProps('name'),
    },
    {
      title: 'Age',
      dataIndex: 'age',
      key: 'age',
      width: '20%',
      ...Search.getColumnSearchProps('age'),
    },
    {
      title: 'Address',
      dataIndex: 'address',
      key: 'address',
      ...Search.getColumnSearchProps('address'),
      sorter: (a, b) => a.address.length - b.address.length,
      sortDirections: ['descend', 'ascend'],
    },
  ];
  return  <div>
    <PageHeader
    className="site-page-header"
    title="لیست رزرو"
    extra = { <Statistic title="تعداد رزروها" value={100}  />}
    avatar={{icon : <UnorderedListOutlined />}}
    subTitle="| ثبت شده در سیستم"
  />
  <DataTable columns={columns} dataSource={data} />
    </div>
};

export default ReservedList;